module.exports = __webpack_public_path__ + "static/media/Akkurat.642dbb05.svg";